import { takeLatest, call, put } from 'redux-saga/effects'
import { createSessionInstance } from 'api/administration/blocks/Create'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { getBrowserTimezone } from 'helpers/timezone.helper'
import { ISessionBlockModel } from 'models/block.model'
import * as fromActions from '../../../actions/blocks.action'

async function handleCreateSessionBlock(data: ISessionBlockModel) {
  return createSessionInstance(data)
}

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}

function* newSessionBlockEffectSaga(action: any) {
  try {
    const { data } = action
    const payload = {
      ...data,
      block_session: {
        ...data.block_session,
        timezone: data.block_session?.timezone || getBrowserTimezone(),
      },
    }
    yield call(handleCreateSessionBlock, payload)
    yield put(fromActions.Actions.clearEdit())
    const {
      block_instance: { lesson_id },
    } = data
    const blocks = yield call(getList, lesson_id)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(blocks))
    SuccessToast(I18n.t('administration.toastMessages.createSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* createSessionWatcherSaga() {
  yield takeLatest(fromActions.SESSION_BLOCK_CREATE, newSessionBlockEffectSaga)
}
